(function () {
  const mountId = 'influenceio-referral-widget-mount';
  const maxAttempts = 40;
  const retryDelay = 250;
  const recoveryDelay = 2000;
  let recoveryTimer;
  let widgetMounted = false;
  let mountObserver;

  function hasWidgetContent(mount) {
    return Boolean(mount && mount.childElementCount > 0);
  }

  function isMountVisible(mount) {
    if (!mount) return false;
    const style = window.getComputedStyle(mount);
    return style.display !== 'none' && style.visibility !== 'hidden';
  }

  function ensureMountIsVisible(mount) {
    if (!mount) return;

    if (mount.style.display === 'none') mount.style.removeProperty('display');
    if (mount.style.visibility === 'hidden') mount.style.removeProperty('visibility');
    if (mount.hidden) mount.hidden = false;
  }

  function scheduleRecovery(delay) {
    window.clearTimeout(recoveryTimer);
    recoveryTimer = window.setTimeout(() => initialiseWidget(0), delay);
  }

  function watchMount(mount) {
    if (!mount || mountObserver) return;

    mountObserver = new MutationObserver(() => {
      ensureMountIsVisible(mount);

      if (hasWidgetContent(mount)) {
        widgetMounted = true;
        return;
      }

      if (mount.dataset.initialising !== 'true') {
        scheduleRecovery(recoveryDelay);
      }
    });

    mountObserver.observe(mount, {
      attributes: true,
      attributeFilter: ['hidden', 'style'],
      childList: true,
    });
  }

  function initialiseWidget(attempt) {
    const mount = document.getElementById(mountId);

    if (!mount) {
      if (attempt < maxAttempts) {
        window.setTimeout(() => initialiseWidget(attempt + 1), retryDelay);
      }
      return;
    }

    ensureMountIsVisible(mount);
    watchMount(mount);

    if (hasWidgetContent(mount) && isMountVisible(mount)) {
      delete mount.dataset.initialising;
      widgetMounted = true;
      mount.dataset.referralWidgetMounted = 'true';
      return;
    }

    if (widgetMounted && hasWidgetContent(mount)) return;

    if (mount.dataset.initialising === 'true') return;

    if (typeof window.influenceioReferralWidget === 'function') {
      mount.dataset.initialising = 'true';
      try {
        window.influenceioReferralWidget(mountId);
        window.setTimeout(() => {
          delete mount.dataset.initialising;

          if (hasWidgetContent(mount) && isMountVisible(mount)) {
            widgetMounted = true;
            mount.dataset.referralWidgetMounted = 'true';
            return;
          }

          widgetMounted = false;
          delete mount.dataset.referralWidgetMounted;
          scheduleRecovery(recoveryDelay);
        }, 1500);
      } catch (error) {
        delete mount.dataset.initialising;
        console.error('Unable to initialise the referral widget.', error);
        if (attempt < maxAttempts) {
          window.setTimeout(() => initialiseWidget(attempt + 1), retryDelay);
        }
      }
      return;
    }

    if (attempt < maxAttempts) {
      window.setTimeout(() => initialiseWidget(attempt + 1), retryDelay);
    }
  }

  function scheduleInitialisation() {
    window.setTimeout(() => initialiseWidget(0), 0);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleInitialisation, { once: true });
  } else {
    scheduleInitialisation();
  }

  window.addEventListener('load', scheduleInitialisation, { once: true });
})();
